module.exports = __webpack_public_path__ + "static/media/Line-Up_Review_Paciente_6.46c167b3.jpeg";